import { List, Map } from 'immutable';

export default Map({
  all: Map({
    loading: false,
    data: List(),
    error: null,
  }),
  popular: Map({
    loading: false,
    data: List(),
    error: null,
  }),
});
